module.exports = __webpack_public_path__ + "assets/img/study_1.2ac77a67.png";